export const LINK_TYPES = {
  DEEP: 'deepLink',
  EXTERNAL: 'externalLink',
  WEBVIEW: 'webView',
} as const;
